import React from 'react';
import { useTranslation } from 'react-i18next';

const PageLoader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-primary-900 to-primary-800">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-white border-t-transparent"></div>
        <p className="mt-4 text-white text-lg">{t('common.loading')}</p>
      </div>
    </div>
  );
};

export default PageLoader;
